import { MagistralDrugRawMaterial as MedicineApiMagistralDrugRawMaterial } from '@dreryk/drerykweb-medicine-api';

import { MagistralDrugRawMaterial } from '../MagistralDrugReadOnly.types';

export const mapMedicineApiMagistralDrugRawMaterialToRawMaterial = (
   medicineApiMagistralDrugRawMaterial: MedicineApiMagistralDrugRawMaterial
): MagistralDrugRawMaterial => ({
   ...medicineApiMagistralDrugRawMaterial,
   quantityUnit: medicineApiMagistralDrugRawMaterial.quantityUnit
      ? medicineApiMagistralDrugRawMaterial.quantityUnit
      : 'NONE',
});
